import { render } from "./FooterCookies.vue?vue&type=template&id=3bbcd5d0&scoped=true"
import script from "./FooterCookies.vue?vue&type=script&lang=js"
export * from "./FooterCookies.vue?vue&type=script&lang=js"

import "./FooterCookies.vue?vue&type=style&index=0&id=3bbcd5d0&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbcd5d0"]])

export default __exports__